import gql from 'graphql-tag'

export const listCancellationReasons = gql`
	query listCancellationReasons {
	  cashAssist {
	    listCancellationReasons {
	      id
	      text
	    }
	  }
	}
`

export default gql`
mutation cancelBill($id: ID!, $reasonId: ID, $reasonText: String) {
	cashAssist {
	  cancellBill(id: $id, reasonId: $reasonId, reasonText: $reasonText) {
	    id
	    closingId
	    isCancelled
	  }
	}
}
`

